import React from 'react';
import Aux from '../../Hoc/Aux/Aux';
import Hero from '../UI/Hero/Hero';
import fulltimeImg from '../../Assets/Images/img15.png';
import Footer from '../Footer/Footer';

const curriculum = (props) => {
    return(
        <Aux>
            <Hero title="24 Weeks Full-Time Courses"
                  classType="hero-overview"
                  img={fulltimeImg}
            />

            <section></section>
            <Aux>
                <Footer />
            </Aux>
        </Aux>
    )
};

export default curriculum;


// WEBPACK FOOTER //
// ./src/Components/FullTime/FullTime.js